import styled from "@emotion/styled";

import { FieldSelect } from "../FieldSelect";

export const LandingPageFieldSelect = styled(FieldSelect)``;
